import React, { Component } from 'react';
import './alert.css';
import { APP_CONST } from '../../constants';

class GeckoAlert extends Component {

    prepareClass() {
        return APP_CONST.ALERT_CLASSES[this.props.type || APP_CONST.ALERT_TYPE_INFO];
    }

	renderClass() {
		return `gecko-alert alert ${this.prepareClass()} ${this.props.className}`;
	}

    render() {
		return (
            <div role="alert" className={this.renderClass()}>

                {this.props.children}

            </div>
        );
    }
}

GeckoAlert.defaultProps = {
    className: '',
}

export default GeckoAlert;